import GV from "./globalVar"
import LoginService from './login';

export default class GlobalVariable{
    userDet = undefined
    lgs = new LoginService();
    msgs = {
        required:'This field is required',
        min:'Minimum 4 values'
    }
    // Refresh(){
    //     const data = {
    //         "RefreshToken":localStorage.getItem('lv'),
    //         "AppUserID":GV.userDet.appUser.appuserID
    //       }
    //             // eslint-disable-next-line no-undef
    //             lgs.RefreshToken(data).then(res=>{
    //             localStorage.setItem('token',res.data.data.accessToken);
    //                 window.location.reload();
    //             })
    
    //     }

}